import * as React from 'react';
import DesignReadyView from '../layouts/DesignReadyView';
// import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { TatData } from 'src/reducers/fileUpload';
import { RowDataManufactur } from 'src/reducers/manufactur';
import { RedesignReasons } from 'src/reducers/completeorderfile';
// import { UserDetail } from '../../reducers/user';

export interface DesignReadyViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    designReadyData: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: () => void;
    onBulkDownloadStl: () => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;
}

class DesignReadyPage extends React.Component<DesignReadyViewProps> {
    render() {
        return (
            <DesignReadyView
                designReadyData={this.props.designReadyData}
                isDownloading={this.props.isDownloading}
                redesignReasons={this.props.redesignReasons}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onDownloadClick={this.props.onDownloadClick}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                onBulkDownload={this.props.onBulkDownload}
                fromDate={this.props.fromDate}
                toDate={this.props.toDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                orderDataTat={this.props.orderDataTat}
                approvalRequired={this.props.approvalRequired}
                redesignRequest={this.props.redesignRequest}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default DesignReadyPage;



// WEBPACK FOOTER //
// ./src/components/DesignReady/DesignReadyPage.tsx